import WebIcon from "../../assets/icons/web.svg?react";
import { ProductionArea } from "../../enums/production-area.enum";
import Button from "../Button";

const useExternalLinkData = (productionArea: ProductionArea) => {
  const data = {
    [ProductionArea.Grinding]: {
      href: "https://new.abb.com/mining/grinding/gearless-mill-drives",
      title: "Gearless mill drive system (GMD)",
      buttonText: "ABB Grinding",
    },
    [ProductionArea.HPR]: {
      href: "https://new.abb.com/power-electronics/high-power-rectifiers",
      title: "High Power Rectifiers",
      buttonText: "ABB HPR",
    },
    [ProductionArea.Hoisting]: {
      href: "https://new.abb.com/mining/underground-mining/mine-hoist-systems",
      title: "Smart hoisting solutions for underground mining",
      buttonText: "ABB Hoisting",
    },
  };

  return data[productionArea];
};

type ExternalLinkButtonProps = {
  productionArea: ProductionArea;
};

function ExternalLinkButton({ productionArea }: ExternalLinkButtonProps) {
  const { href, title, buttonText } = useExternalLinkData(productionArea);

  return (
    <a href={href} target="_blank" rel="noopener noreferrer" title={title}>
      <Button
        variant="secondary"
        text={buttonText}
        size="small"
        svg={<WebIcon />}
      />
    </a>
  );
}
export default ExternalLinkButton;
